// todo: 换回正式环境
// export const domain = "https://aws-mall-test.ogl-dragon.com";
export const domain = "https://aws-mall.ogl-dragon.com";

export const getEarnedListApi = `${domain}/api/v1/customer-center/get-earned-customer-points-transaction-log-list-paging`;
export const getUsedListApi = `${domain}/api/v1/customer-center/get-used-customer-points-transaction-log-list-paging`;
export const getAllPointsListApi = `${domain}/api/v1/customer-center/get-customer-points-transaction-log-list-paging`;
// 查询用户积分列表
export const getCustomerPointsListApi = `${domain}/api/v1/customer-center/get-customer-points-list-paging`;
// 查询用户优惠券列表
export const getCustomerCouponsListApi = `${domain}/api/v1/customer-center/get-discount-code-list-paging`;
// 获取礼品卡列表
export const getGiftCardListApi = `${domain}/api/v1/customer-center/get-gift-card-list-paging`;
// 获取折扣列表
export const getDiscountListApi = `${domain}/api/v1/customer-center/get-discount-code-list-paging`;
// 查询活动奖品券列表
export const getPrizeListApi = `${domain}/api/v1/activity/get-prize-list-paging`;

// 兑换礼品卡
export const redeemGiftCardApi = `${domain}/api/v1/customer-center/redeem-gift-card`;
// 兑换折扣卡
export const redeemDiscountCardApi = `${domain}/api/v1/customer-center/redeem-discount-code`;
